

























import CalendarCloseButton from '@/components/announcementbar/christmas-calendar/subcomponents/CalendarCloseButton.vue';
import ValidationHelper from '@/helpers/ValidationHelper';
import Vue from 'vue';

interface IInformationOverlayComponent {
  locizeNameSpace: string;
}

export default Vue.extend({
  name: `InformationOverlay`,
  components: { CalendarCloseButton },
  data(): IInformationOverlayComponent {
    return {
      locizeNameSpace: `announcement-bar-ufe:`,
    };
  },
  props: {
    type: {
      required: true,
      validator: val => ValidationHelper.isStringOrNull(val),
    },
  },
  methods: {
    closeOverlay(): void {
      this.$emit(`close`);
    },
  },
});
